export default {
  income: [],
  expenses: [],
};
